if ($(window).width() > 798) {
      if ($('.header').hasClass('header-fixed--true')){
        if (!$('.main-nav__wrapper').hasClass('sticky_nav')) {
          $( window ).scroll(function() {
            if ($(this).scrollTop() > 250) {
              //$( ".sticky_nav--stick .header__logo" ).hide();
              $( ".sticky_login" ).show();
              $( ".sticky_search" ).show();
              $( ".sticky_try-here-btn" ).show();
              $( ".sticky_try-here2-btn" ).show();
              $( ".sticky_logo" ).show();
              $( ".menu" ).addClass('sticky_menu')
              $( ".sticky_login" ).addClass('sticky_login-align');
              $( ".mini_cart" ).addClass('sticky_cart-align');
            }
            if($(this).scrollTop() < 250){
              //$( ".sticky_nav--stick .header__logo" ).show();
              $( ".sticky_login" ).hide();
              $( ".sticky_search" ).hide();
              $( ".sticky_try-here-btn" ).hide();
              $( ".sticky_try-here2-btn" ).hide();
              $( ".sticky_logo" ).hide();
              $( ".menu" ).removeClass('sticky_menu');
              $( ".sticky_login" ).removeClass('sticky_login-align');
              $( ".mini_cart" ).removeClass('sticky_cart-align');
            }
          });
        }
      }
    }

$('#hamburger-menu').on('click', function(){
	$('.desktop-dropdown-menu').slideDown();
  	$('.hamburger-icon').hide();
    $('.close-menu-icon').show();
});

$('#close-menu-icon').on('click', function(){
	$('.desktop-dropdown-menu').slideUp();
  	$('.hamburger-icon').show();
    $('.close-menu-icon').hide();
});

$('.mobile-hamburger-icon').on('click', function(){
  	$('.mobile-hamburger-icon').hide();
    $('.mobile-close-menu-icon').show();
});

$('.mobile-close-menu-icon').on('click', function(){
  	$('.mobile-hamburger-icon').show();
    $('.mobile-close-menu-icon').hide();
});


  $('.select-variant-btn').on('click', function(){
  $('.collection_swatch_options').slideDown();
  $('.select-variant-btn').hide();
});


/* Progress bar 
(function () {
  const goal = 200;

  function getPrice() {
    const priceText = document.querySelector('.slidecart-subtotal')?.textContent || "₪0";
    return parseFloat(priceText.replace(/[^\d.]/g, ""));
  }

  function renderProgressBar() {
    const current = getPrice();
    const remaining = Math.max(goal - current, 0);
    const percent = Math.min((current / goal) * 100, 100);

    const target = document.getElementById('sca-promotion-glider');
    if (!target) return;

    const existingWrapper = document.getElementById("progress-wrapper");
    if (!existingWrapper) {
      const wrapper = document.createElement("div");
      wrapper.id = "progress-wrapper";
      wrapper.innerHTML = `
        <div style="background-color: #eee; border-radius: 20px; height: 12px; position: relative; margin-bottom: 6px;">
          <div class="gift-bar" style="background-color: #b48fc2; width: ${percent}%; height: 100%; border-radius: 20px; transition: width 0.3s;"></div>
          <div class="gift-icon" style="position: absolute; left: calc(${percent}% - 10px); top: -6px; font-size: 14px;">
            <img style="width: 25px;" src="https://cdn.shopify.com/s/files/1/1345/2813/files/Progress_bar_button_shadow.png?v=1754470107">
          </div>
        </div>
      `;
      target.parentElement.insertBefore(wrapper, target);
    } else {
      const bar = document.querySelector(".gift-bar");
      const icon = document.querySelector(".gift-icon");

      if (bar) bar.style.width = `${percent}%`;
      if (icon) icon.style.left = `calc(${percent}% - 10px)`;
    }
  }

  function observeCartSubtotal() {
    const subtotalEl = document.querySelector('.slidecart-subtotal');
    if (!subtotalEl) return;

    console.log("✅ התחברנו ל־.cart_subtotal");

    const priceObserver = new MutationObserver((mutationsList) => {
      console.log("🟣 שינוי במחיר או תוכן בעגלה זוהה!");
      renderProgressBar();
    });

    priceObserver.observe(subtotalEl, {
      childList: true,
      subtree: true,
    });
  }

  const globalObserver = new MutationObserver(() => {
    if (document.querySelector('.slidecart-subtotal')) {
      observeCartSubtotal();
      renderProgressBar();
    }
  });

  globalObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.slidecart-subtotal')) {
      observeCartSubtotal();
      renderProgressBar();
    }
  });
})();
  END Progress bar */


 /* Progress bar multi
(function () {
  const milestones = [
    { amount: 200, label: "מוקטן אחד" },
    { amount: 400, label: "מוקטנים 2" },
    { amount: 600, label: "מוקטנים 3" },
    { amount: 800, label: "Travel Kit" }
  ];

  function getPrice() {
    const priceText = document.querySelector('.slidecart-subtotal')?.textContent || "₪0";
    return parseFloat(priceText.replace(/[^\d.]/g, ""));
  }

  function getCurrentMilestoneIndex(current) {
    let index = -1;
    milestones.forEach((step, i) => {
      if (current >= step.amount) index = i;
    });
    return index;
  }

  function renderMultiStepProgressBar() {
    const current = getPrice();
    const maxAmount = milestones[milestones.length - 1].amount;
    const percent = Math.min((current / maxAmount) * 100, 100);
    const activeIndex = getCurrentMilestoneIndex(current);

    const target = document.getElementById('sca-promotion-glider');
    if (!target) return;

    if (!document.getElementById("progress-wrapper")) {
      const wrapper = document.createElement("div");
      wrapper.id = "progress-wrapper";

      // ✅ ודא שה־wrapper תופס 100% רוחב
      wrapper.style.width = "100%";
      wrapper.style.boxSizing = "border-box";
      wrapper.style.padding = "0 10px";

      const stepsHTML = milestones.map((step, index) => {
        return `
          <div class="milestone ${index <= activeIndex ? "active" : ""}" style="flex: 1; text-align: center;">
            <div style="
              width: 20px;
              height: 20px;
              margin: 0 auto 5px;
              border-radius: 50%;
              background-color: ${index <= activeIndex ? "#b48fc2" : "#ddd"};
              background-image: ${index <= activeIndex ? "url('https://cdn.shopify.com/s/files/1/1345/2813/files/Progress_bar_button_shadow.png?v=1754470107')" : ""};
              background-position: center;
              background-size: contain;
            "></div>
            <div style="font-size: 12px; color: ${index <= activeIndex ? "#fff" : "#000"};">${step.label}</div>
          </div>
        `;
      }).join("");

      wrapper.innerHTML = `
        <div style="width: 100%; padding: 0;">
          <div style="
            width: 100%;
            background-color: #eee;
            height: 35px;
            border-radius: 40px;
            position: relative;
            margin-bottom: 3px;
          ">
            <div style="
              background-color: #b48fc2;
              width: ${percent}%;
              height: 100%;
              transition: width 0.4s ease;
              border-radius: 40px;
            "></div>
            <div style="
              display: flex;
              justify-content: space-between;
              position: absolute;
              top: -14px;
              left: 0;
              right: 0;
              width: 100%;
            ">
              ${stepsHTML}
            </div>
          </div>
        </div>
      `;
      target.parentElement.insertBefore(wrapper, target);
    } else {
      const progressBar = document.querySelector("#progress-wrapper div > div > div");
      if (progressBar) {
        progressBar.style.width = `${percent}%`;
      }

      const milestonesEls = document.querySelectorAll("#progress-wrapper .milestone");
      milestonesEls.forEach((el, index) => {
        const circle = el.querySelector("div");
        if (circle) {
          circle.style.backgroundColor = index <= activeIndex ? "#b48fc2" : "#ddd";
        }
      });
    }
  }

  function observeCartSubtotal() {
    const subtotalEl = document.querySelector('.slidecart-subtotal');
    if (!subtotalEl) return;

    const priceObserver = new MutationObserver(() => {
      renderMultiStepProgressBar();
    });

    priceObserver.observe(subtotalEl, {
      childList: true,
      subtree: true,
    });
  }

  const globalObserver = new MutationObserver(() => {
    if (document.querySelector('.slidecart-subtotal')) {
      observeCartSubtotal();
      renderMultiStepProgressBar();
    }
  });

  globalObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.slidecart-subtotal')) {
      observeCartSubtotal();
      renderMultiStepProgressBar();
    }
  });
})();

END  Progress bar multi */